import { render, staticRenderFns } from "./price-list-filter.vue?vue&type=template&id=5dd00b4d&"
import script from "./price-list-filter.vue?vue&type=script&lang=js&"
export * from "./price-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports